module.exports = __webpack_public_path__ + "01_short_yellow.a33d1317.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_short_yellow.png
// module id = U4qQ
// module chunks = 0